import { render, staticRenderFns } from "./BaseSnackbar.vue?vue&type=template&id=21d61fff&scoped=true"
import script from "./BaseSnackbar.vue?vue&type=script&lang=js"
export * from "./BaseSnackbar.vue?vue&type=script&lang=js"
import style0 from "./BaseSnackbar.vue?vue&type=style&index=0&id=21d61fff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d61fff",
  null
  
)

export default component.exports